import React, {useState, useEffect} from 'react';
import { useContext } from 'react';
import { ShopContext } from './shopinfo';
import {Link} from 'react-router-dom';
import { mapData } from '../datamapper';
import '../carousel.css';
import LandingPage from './user_landingpage';

const CardCarousel = () => {
    const shopData = useContext(ShopContext);

   

    const [nexusSelect, setNexusSelect] = useState([]);
    const [itemsToShow, setItemsToShow] = useState(5);
    const [currentIndex, setCurrentIndex] = useState(0);
   
    const preisAnzeige = (preis) => {
        return preis.toFixed(2).replace('.',',');
    }

    useEffect(() => {
        const fetchNexusSelect = async () => {
            try {
                const apiUrl = `/search?stichwort=&count=50&offset=0&sort=rang&sort_order=desc&produktgruppe=AL&lieferbar=1`;
                const response = await fetch(apiUrl);
                if (!response.ok) {
                    throw new Error('Failed to fetch search results');
                }
                const data = await response.json();
                const mappedData = mapData(data);
                setNexusSelect(mappedData); // Assuming the response is an array of search results
            } catch (error) {
                console.error('Error fetching search results:', error);
            }
        };

        fetchNexusSelect();
    }, []); 


    

    useEffect(() => {
        const handleResize = () => {
          if (window.innerWidth <= 576) {
            setItemsToShow(1);
          } else if (window.innerWidth <= 768) {
            setItemsToShow(2);
          } else if (window.innerWidth <= 992) {
            setItemsToShow(3);
          } else if (window.innerWidth <= 1200) {
            setItemsToShow(4);
          } else {
            setItemsToShow(5);
          }
        };
    
        window.addEventListener('resize', handleResize);
        handleResize();
    
        return () => window.removeEventListener('resize', handleResize);
      }, []);
    



    const nextSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % nexusSelect.length);
    };

    const prevSlide = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + nexusSelect.length) % nexusSelect.length);
    };

    useEffect(() => {
        const interval = setInterval(nextSlide, 3500);
        return () => clearInterval(interval);
    }, [nexusSelect.length, itemsToShow]);

    if (!shopData) {
        return <p>Loading shop information...</p>;
    }

    return (

            <div className="contentContainer">
                    <LandingPage />

                    <br />
                    <hr className="hrUmb" />
                    <br />
                    
                    <div className="carouselContainer">
                        <button onClick={prevSlide} className="carouselButton prevButton" />
                    <div className="carouselWrapper">
                            <div
                                className="carouselContent"
                                style={{ transform: `translateX(-${currentIndex * (100 / itemsToShow)}%)` }}
                                >
                                {nexusSelect.map((item) => (
                                            <div className="carouselItem" key={item.id}>
                                                <div className="bibResultsBox">
                                                        <div className="bibImgContainer umBorderRight">
                                                            
                                                        <Link to={`/productdetails/${item.ean}`}>
                                                                    
                                                                
                                                                
                                                                    {Array.isArray(item.cover) && item.cover.length > 0 ? (
                                                                        // Display the first entry in the cover array
                                                                        <img styles={{height: '200px'}} src={item.cover[0]} alt="" />
                                                                    ) : (
                                                                        // Display a placeholder image if cover is not an array or is empty
                                                                        <img styles={{height: '200px'}} src="/assets/img/icons/noImage.png" alt="" />
                                                                    )}        


                                                                </Link> 
                                                        </div>    
                                                        <div className="card-boy">
                                                            <div className="bibResultBoxTAP umBorderLeft">
                                                                <b className="card-title">{item.titel}</b>
                                                                <br />
                                                                
                                                            </div>
                                                           
                                                            <div className="bibResultBoxVerlag umBorderLeft">   
                                                                <p className="card-text">{item.autor}</p> 
                                                                <p className="card-text">{item.verlag}</p>
                                                            </div>
                                                            
                                                               
                                                                    
                                                                    
                                                                  
                                                                <div className="bibResultBoxButtons umBorderLeft umBorderRight">  
                                                                
                                                                <p className="card-text">
                                                                     <b>{preisAnzeige(item.preis)} €</b>
                                                                     <div className='nexusMeldetext'>
                                                                        <div className={item.meldetext}>{item.meldetext}</div>
                                                                    </div>  
                                                                    </p>       
                                                                
                                                                </div>  
                                                              
                                                        </div>
                                                </div>        
                                            </div>
                                        ))} 
                            </div>
                    </div>
                    <button onClick={nextSlide} className="carouselButton nextButton" />
                    </div>
        </div>
      );

};

export default CardCarousel;